import { createTheme } from "@mui/material";
const theme = createTheme({
  palette: {
    primary: {
      main: "#1a2840",
    },
    secondary: {
      main: "#3C47EA",
    },
    info: {
      main: "#0090B7",
    },
    success: {
      main: "#00C9A5",
    },
    error: {
      main: "#E3597A",
    },
    warning: {
      main: "#00C9A5",
    },
  },
});
export default theme;
